/** "1 file" / "2 files": the noun agrees with the count. */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
    return `${count} ${count === 1 ? singular : plural}`;
}

/** "Page 3" / "Pages 3–4" for 1-based page numbers: how a document is named in the UI. */
export function rangeLabel(start: number | string, end: number | string): string {
    return String(start) === String(end) ? `Page ${start}` : `Pages ${start}–${end}`;
}

/** The file's name for titles and headings; never an internal id. */
export function fileDisplayName(
    fileRow: { fileName?: string | null; title?: string | null } | undefined,
): string {
    return fileRow?.fileName ?? fileRow?.title ?? 'Untitled file';
}

/** "Page splits — report.pdf"; just the editor name while the file is still loading. */
export function editorTitle(
    editor: string,
    fileRow: { fileName?: string | null; title?: string | null } | undefined,
): string {
    const name = fileRow?.fileName ?? fileRow?.title;
    return name ? `${editor} — ${name}` : editor;
}

/** "pp. 13–48" / "p. 13" for 0-based page bounds, or `null` when either is missing. */
export function pageRangeLabel(
    startPage: number | null | undefined,
    endPage: number | null | undefined,
): string | null {
    if (startPage == null || endPage == null) return null;
    const start = startPage + 1;
    const end = endPage + 1;
    return start === end ? `p. ${start}` : `pp. ${start}–${end}`;
}

/** Doc chip text: type, then pages (tells same-type docs apart), then the doc's own title. */
export function docChipLabel(doc: {
    typeLabel: string;
    startPage?: number | null;
    endPage?: number | null;
    title: string | null;
}): string {
    const pages = pageRangeLabel(doc.startPage, doc.endPage);
    return `${doc.typeLabel}${pages ? ` · ${pages}` : ''}${doc.title ? ` — ${doc.title}` : ''}`;
}
